import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import ToggleBox from '../../toggle-box';

const AssociationFilter = ({
  onAssociationChange,
  toggleFilter,
  showFilter,
  associations
}) => {
  return (
    <div className='filter association-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Association</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='association-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.sortBy(association => association.label),
                    fp.map(
                      ({ value, label, selected }) => {
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter', { selected })} id='selection' key={value} onClick={
                          () => {
                            onAssociationChange(value)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={value}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{label}</span>
                        </Row>
                      }
                    )
                  )(associations)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )
}

const getUpdatedAssociations = (associations, associationToToggle) => fp.flow(
  fp.map(
    (association) => ({
      ...association,
      selected: association.value === associationToToggle ? !association.selected : association.selected
    })
  )
)(associations)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    ({ associations }) => ({
      associations: fp.map(
        (association) => ({
          ...association,
          selected: false
        })
      )(associations)
    }),
    {
      setAssociations: () => (associations) => ({
        associations
      }),
      resetAssociations: ({ associations }) => (filter) => ({
        associations: fp.map(
          (association) => ({
            ...association,
            selected: fp.includes(association.value)(filter.associations)
          })
        )(associations)
      })
    }
  ),
  withHandlers({
    onAssociationChange: ({ onChange, setAssociations, associations }) => (associationName) => {
      const updatedAssociations = getUpdatedAssociations(associations, associationName)
      setAssociations(updatedAssociations)
      const selectedAssociations = fp.flow(
        fp.filter('selected'),
        fp.map('value')
      )(updatedAssociations)
      onChange({
        associations: selectedAssociations
      })
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { filter, resetAssociations } = this.props
      if (!fp.isEqual(filter)(prevStat.filter)) {
        resetAssociations(filter)
      }
    }
  })
)(AssociationFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/association-filter.js